export default __webpack_public_path__ + "static/media/0022.7bbf0fdf.WAV";